module.exports = __webpack_public_path__ + "images/ExternalPromo/weebly-387671-468_60.gif?4ce76";